import { TYPES } from "../actions";

const initialState = {
  c3dInfos: [],
  totalCount: 0,
  currentC3DInfo: null,
  loading: false
};

export const tkt1C3DInfoReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_C3D_INFOS_SUCCESS:
      return { 
        ...state, 
        c3dInfos: action.payload.data.result, 
        totalCount: action.payload.data.totalCount > -1 ? action.payload.data.totalCount : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_C3D_INFOS_FAIL:
      return { 
        ...state, 
        c3dInfos: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_C3D_INFO_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentC3DInfo: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_C3D_INFO_BY_ID_FAIL:
      return { 
        ...state, 
        currentC3DInfo: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_C3D_INFO_SUCCESS:
      return { 
        ...state, 
        c3dInfos: [action.payload.data, ...state.c3dInfos],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_C3D_INFO_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_C3D_INFO_SUCCESS:
      return { 
        ...state, 
        c3dInfos: state.c3dInfos.map(info => 
          info._id === action.payload.data._id ? action.payload.data : info
        ),
        currentC3DInfo: state.currentC3DInfo && state.currentC3DInfo._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentC3DInfo,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_C3D_INFO_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_C3D_INFO_SUCCESS:
      return { 
        ...state, 
        c3dInfos: state.c3dInfos.filter(info => info._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentC3DInfo: state.currentC3DInfo && state.currentC3DInfo._id === action.payload.id 
          ? null 
          : state.currentC3DInfo,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_C3D_INFO_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
